/**
 * useLeaveRequests — React Query hook saját szabadság kérelmek lekérdezéséhez
 */

import { useQuery } from '@tanstack/react-query';
import { getMyLeaveRequests, type LeaveRequest } from '../api/hr-api';

export const leaveRequestsQueryKey = ['hr', 'leave', 'my-requests'] as const;

export function useLeaveRequests() {
  return useQuery<LeaveRequest[]>({
    queryKey: leaveRequestsQueryKey,
    queryFn: async () => {
      const res = await getMyLeaveRequests();
      return res.data;
    },
    staleTime: 30_000,
  });
}
